<mobi-product-hero
  [headerImage]="entity().headerImage"
  [headerImageMobile]="entity().headerImageMobile"
  [title]="entity().title"
  [subtitle]="entity().subtitle"
  [superTitle]="entity().superTitle"
  [lead]="entity().lead"
  [contentLinks]="contentLinks()"
></mobi-product-hero>
@if (entity().paragraphs) {
  <div class="page-content">
    @for (paragraph of entity().paragraphs; track paragraph?.uuid ?? $index) {
      @if (paragraph) {
        <mobi-paragraph-loader
          [bundle]="paragraph.type"
          [data]="{ paragraph: paragraph }"
        />
      }
    }
  </div>
}
